module.exports = __webpack_public_path__ + "static/media/cc-visa.f5dcfb25.svg";